import { NgModule } from '@angular/core';
import {
  ChangePasswordDialogComponent,
} from './change-password/change-password-dialog/change-password-dialog.component';
import { MaterialModule } from '@sbd-doug-frontend/app/shared/material.module';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';
import { SharedChangePasswordComponent } from './change-password/change-password.component';
import { SharedChangePasswordService } from './change-password/change-password.service';
import { AddressFormComponent } from './address-form/address-form.component';
import { FileCabinetComponent } from './file-cabinet/file-cabinet.component';
import { PermissionHandlerComponent } from './permission-handler/permission-handler.component';
import { UtilityCardComponent } from './system-tools/utility-card/utility-card.component';
import { PermissionsModule } from '@sbd-doug-frontend/app/shared/permissions/permissions.module';
import { CIPXPillSwitcherComponent } from './pill-switcher/pill-switcher.component';

// Drawer exports
export { CIPXDrawerComponent } from '../ui/drawer/drawer.component';
export { CIPXDefaultDrawerComponent } from '../ui/drawer/default-drawer.component';
export { CIPXVerticalDrawerComponent } from '../ui/drawer/vertical-drawer-component';
export {
  CIPXDrawerManagerService, DrawerConfig, DrawerRef, DRAWER_DATA, DRAWER_REF,
} from '../ui/drawer/drawer-manager.service';
export { CIPXDrawerContentInterface, ExtractDrawerData } from '../ui/drawer/drawer-content.interface';

// Drawer content styles are available at:
// @import '@sbd-doug-frontend/shared/lib/shared-components/drawer/drawer-content.scss';

@NgModule({
  imports: [
    MaterialModule
    , SharedModule
    , FileCabinetComponent
    , PermissionsModule
    , UtilityCardComponent
    , CIPXPillSwitcherComponent
  ],
  exports: [
    ChangePasswordDialogComponent
    , SharedChangePasswordComponent
    , AddressFormComponent
    , FileCabinetComponent
    , PermissionHandlerComponent
    , UtilityCardComponent
    , CIPXPillSwitcherComponent
  ],
  declarations: [ChangePasswordDialogComponent, SharedChangePasswordComponent, AddressFormComponent,
    PermissionHandlerComponent],
  providers: [],
})
export class SharedComponentsModule {
}
